export default 'https://help.acuitis.kazaar.com/';
